<template>
 <div class="wrapper">

  <div >
      <CRow>
     <CCol col="4" >
    <CCard>
    <CCardHeader><b>Group Info</b></CCardHeader>
      <CListGroup >
        <CListGroupItem href="#"> Group Name :  {{ datas.data.name }} </CListGroupItem>
        <CListGroupItem  class="d-flex justify-content-between" href="#"> Coach Name :  {{ coachname }}
        <CButton class="ml-3" variant="outline" color="info" size="sm" @click="openManageCoach(datas.data.id, datas.data.coach_id)">  Change Coach </CButton>
        <CButton v-if="datas.data.coach_id" class="ml-3" variant="outline" color="danger" size="sm" @click="removeCoach(datas.data.id)">  Remove Coach </CButton>
        </CListGroupItem>
        <CListGroupItem href="#"> Description :  {{ datas.data.description }} </CListGroupItem>
        </CListGroup>
    </CCard>
    </CCol>
     <CCol col="8">
    <CCard>
    <CCardHeader><b>Icare List</b> <CButton class="ml-2" size="sm" variant="outline" color="info" @click="openManageIcare(datas.data.id)">Manage iCare</CButton>
    </CCardHeader>
    <CListGroup>
      <CListGroupItem  v-for="item in datas.data.icare" :key="item.id"  >
        <CRow>
          <CCol>
          {{ item.name }}
          </CCol>
          <CCol class="col-2" >
          <CButton  size="sm" variant="outline" color="success"  @click="show_icare(item.id)" >Show </CButton>
          </CCol>
        </CRow>
       </CListGroupItem>
    </CListGroup>
    </CCard>
    </CCol>
    </CRow>


  <alertmodal></alertmodal>
  <managecoachmodal></managecoachmodal>
  <manageicaremodal></manageicaremodal>
    </div>
 </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

import group from '@/services/coachgroup'
import managecoachmodal from './coach_group_manage_coach';
import manageicaremodal from './coach_group_manage_icare';

import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';
import store from '@/store.js'

export default {
name: 'detailmodal',
components: { alertmodal ,manageicaremodal,managecoachmodal },
  data () {
    return {
      mode: '',
      datas:[],
      icare:[],
      coachname:'',
      }
  },
 mounted (){
     this.load()

      EventBus.$on('PAGE_UPDATE', (data) => {
      if(data){
          this.load();
      }
    });
   },
 methods:{
    openManageIcare: function (id) {
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit group (including edit coach & iCares for the group)') !== -1){
          //IF ALLOW
      var params = {title: 'Manage Icare', mode:'edit',data:id}
      EventBus.$emit('OPEN_MODAL_MANAGE_ICARE', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        }
      }
      //SET END
    },
    openManageCoach: function (id) {
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit group (including edit coach & iCares for the group)') !== -1){
          //IF ALLOW
      var params = {title: 'Manage Coach', mode:'edit',data:id}
      EventBus.$emit('OPEN_MODAL_MANAGE_COACH', params)
      console.log('open modal coach')
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        }
      }
      //SET END
    },
    removeCoach: function (id) {
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit group (including edit coach & iCares for the group)') !== -1){
          //IF ALLOW
            if(confirm("Do you really want to remove coach?")){
              group.removeCoach(this.$route.query.Pud)
              .then(res => {
                // this.load()
                this.coachname = "";
                EventBus.$emit('PAGE_UPDATE', true)
                var params = {title: 'Success', mode:'success', data:res.message}
                EventBus.$emit('OPEN_MODAL_ALERT', params)
              }).catch ((err) => {
                var params = {title: 'Error', mode:'danger', data:err.response.data.message}
                EventBus.$emit('OPEN_MODAL_ALERT', params)
                console.log(param)
              })
            }
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        }
      }
      //SET END
    },
    show_icare: function(uuid){

      //muncul detail at same page, tetapi saat back hanya url nya yg kerubah.
      // this.$router.push({path: '/member/member_detail',query: {Pud:uuid} })
      // window.location.reload()

      //new tab
      let routeData = this.$router.resolve({path: '/icare/icare_detail',query: {Pud:uuid} })
      window.open(routeData.href, '_blank');

    },
     show_member: function(uuid){

      //muncul detail at same page, tetapi saat back hanya url nya yg kerubah.
      // this.$router.push({path: '/member/member_detail',query: {Pud:uuid} })
      // window.location.reload()

      //new tab
      let routeData = this.$router.resolve({path: '/member/member_detail',query: {Pud:uuid} })
      window.open(routeData.href, '_blank');

    },
   load(){
     group.getGroupbyID(this.$route.query.Pud)
      .then(res => {
      this.datas =res

            if(res.data.coach !== null){
                this.coachname = res.data.coach.firstname + " " + res.data.coach.lastname
            }

      })
    },

  }
}

</script>
